// Generated by CoffeeScript 1.12.7
(function () {
  var Accept, AuditTrailRetriever, Clone, Name, PayNow, Preview, Projects, Share, capitalize, pick, ref, ref1;

  (ref = require("lodash")), (capitalize = ref.capitalize), (pick = ref.pick);

  (ref1 = require("Common/Utils/ImageImports")),
    (Accept = ref1.Accept),
    (Projects = ref1.Projects),
    (Name = ref1.Name),
    (Clone = ref1.Clone),
    (Share = ref1.Share),
    (Preview = ref1.Preview),
    (PayNow = ref1.PayNow);

  module.exports = AuditTrailRetriever = (function () {
    function AuditTrailRetriever($http, $location, $log, imageLocation, apiBaseUrl, primaryDomain, getFullName) {
      var arrivedOnPageEvent,
        auditBackupEvent,
        emailedCopyEvent,
        fetchAuditTrail,
        getAccepterEvents,
        getCardSummary,
        identifiedAsEvent,
        makeAuditTrail,
        paidEvent,
        publishedPageEvent,
        signedAndAcceptedEvent;
      this.retrieve = function (projectId) {
        return fetchAuditTrail(projectId).then(function (projectData) {
          return makeAuditTrail(projectData);
        });
      };
      fetchAuditTrail = function (projectId) {
        return $http.get(apiBaseUrl + "/projects/" + projectId + "/audit-trail").then(function (result) {
          return result.data;
        });
      };
      makeAuditTrail = function (data) {
        var accepter, accepterEvents, backupHash, events, i, j, len, projectEvents, ref2;
        events = [];
        projectEvents = [publishedPageEvent(data), auditBackupEvent(data), emailedCopyEvent(data)];
        if (data.acceptanceData.payment) {
          projectEvents.push(paidEvent(data));
        }
        if (data.acceptanceData.accepters != null) {
          accepterEvents = [];
          backupHash = data.acceptanceData.backupHash;
          ref2 = data.acceptanceData.accepters;
          for (i = j = 0, len = ref2.length; j < len; i = ++j) {
            accepter = ref2[i];
            accepterEvents = accepterEvents.concat(getAccepterEvents(accepter, backupHash, i));
          }
        } else {
          accepterEvents = getAccepterEvents(data.acceptanceData);
        }
        events = accepterEvents.concat(projectEvents);
        return _.sortBy(events, "timestamp");
      };
      getAccepterEvents = function (acceptanceData, backupHash, accepterNum) {
        var events, ref2;
        events = [arrivedOnPageEvent(acceptanceData), signedAndAcceptedEvent(acceptanceData, backupHash, accepterNum)];
        if (((ref2 = acceptanceData.identification) != null ? ref2.data : void 0) != null) {
          events.push(identifiedAsEvent(acceptanceData));
        }
        return events;
      };
      publishedPageEvent = function (data) {
        return {
          name: "Published Page",
          cssClass: "published",
          icon: Projects,
          timestamp: data.publishedAt || data.createdAt,
          subtitle: getFullName(data.user),
          table: [
            {
              label: "Email",
              value: data.user.email,
            },
          ],
        };
      };
      arrivedOnPageEvent = function (acceptanceData) {
        var ref2, timestamp;
        if ((ref2 = acceptanceData.identification) != null ? ref2.time : void 0) {
          timestamp = acceptanceData.identification.time;
        } else {
          timestamp = acceptanceData.sessionStartedAt;
        }
        return {
          name: "Page viewed",
          cssClass: "session-start",
          icon: Preview,
          timestamp: timestamp,
          subtitle: acceptanceData.name,
          copy: "IP: " + acceptanceData.ip,
        };
      };
      identifiedAsEvent = function (acceptanceData) {
        var idType, identification;
        identification = acceptanceData.identification;
        switch (identification.type) {
          case "GoogleSignIn":
            idType = "Google";
            break;
          case "EmailConfirmation":
            idType = "Email Confirmation";
            break;
          case "SpringboardConfirmation":
            idType = "Qwilr Springboard";
        }
        return {
          name: "Identified As",
          cssClass: "identified",
          icon: Name,
          timestamp: acceptanceData.sessionStartedAt,
          subtitle: acceptanceData.identification.email,
          table: [
            {
              label: "IP",
              value: identification.ip,
            },
            {
              label: "Using",
              value: idType,
            },
            {
              label: "Name",
              value: identification.data.name || identification.data.username,
            },
          ],
        };
      };
      auditBackupEvent = function (data) {
        var jsonLinkedText, jsonUrl, pdfLinkedText, pdfUrl;
        jsonUrl = imageLocation.vault(data.acceptanceData.backupHash + "-audit-trail.json");
        jsonLinkedText = '<a target="_blank" href="' + jsonUrl + '">JSON format</a>';
        pdfUrl = imageLocation.vault(data.acceptanceData.backupHash + "-project.pdf");
        pdfLinkedText = '<a target="_blank" href="' + pdfUrl + '">PDF format</a>';
        return {
          name: "Audit Backup",
          cssClass: "audit-backup",
          icon: Clone,
          timestamp: data.acceptanceData.backupCreatedAt,
          subtitle: "Record of accepted project:",
          copy: pdfLinkedText + " / " + jsonLinkedText,
        };
      };
      emailedCopyEvent = function (data) {
        var accepter, emails, j, len, ref2;
        emails = [data.user.email];
        if (data.acceptanceData.accepters != null) {
          ref2 = data.acceptanceData.accepters;
          for (j = 0, len = ref2.length; j < len; j++) {
            accepter = ref2[j];
            emails.push(accepter.email);
          }
        } else {
          emails.push(data.acceptanceData.email);
        }
        return {
          name: "Emailed Copy",
          cssClass: "emailed-copy",
          icon: Share,
          timestamp: data.acceptanceData.backupCreatedAt,
          subtitle: "Delivered to all parties:",
          copy: emails.join("<br>"),
        };
      };
      paidEvent = function (data) {
        var brand, cardSummary, copy, last4;
        cardSummary = getCardSummary(data);
        if (cardSummary != null) {
          (brand = cardSummary.brand), (last4 = cardSummary.last4);
          brand = capitalize(brand);
          copy = "By " + brand + " (card ending in " + last4 + ")";
        } else {
          copy = "";
        }
        return {
          name: "Paid",
          cssClass: "paid",
          icon: PayNow,
          timestamp: data.acceptanceData.payment.timestamp,
          copy: copy,
          amount: data.acceptanceData.payment.decimalAmount,
          currency: data.acceptanceData.payment.currency,
        };
      };
      getCardSummary = function (data) {
        var e, paymentObject, ref2;
        try {
          paymentObject = data.acceptanceData.payment;
          if (((ref2 = paymentObject.charge) != null ? ref2.source : void 0) != null) {
            return pick(data.acceptanceData.payment.charge.source, ["brand", "last4"]);
          } else if (paymentObject.intent != null) {
            return pick(paymentObject.intent.charges.data[0].payment_method_details.card, ["brand", "last4"]);
          }
        } catch (error) {
          e = error;
          $log.error("Error retrieving card summary for audit overlay: " + e);
        }
        return null;
      };
      signedAndAcceptedEvent = function (acceptanceData, backupHash, accepterNum) {
        var event, fields, ref2, ref3, signatureImg;
        if (backupHash == null) {
          backupHash = null;
        }
        if (accepterNum == null) {
          accepterNum = null;
        }
        if (backupHash == null) {
          backupHash = acceptanceData.backupHash;
        }
        event = {
          name: "Signed & Accepted",
          cssClass: "signed-accepted",
          icon: Accept,
          timestamp: acceptanceData.acceptedAt,
          table: [
            {
              label: "IP",
              value: acceptanceData.ip,
            },
            {
              label: "Email",
              value: acceptanceData.email,
            },
            {
              label: "Company",
              value: acceptanceData.legalEntity || "N/A",
            },
          ],
        };
        if ((ref2 = acceptanceData.postAcceptance) != null ? ref2.url : void 0) {
          event.table.push({
            label: "Post Acceptance",
            value: acceptanceData.postAcceptance.url,
          });
        }
        if (acceptanceData.esigned) {
          if (accepterNum != null) {
            signatureImg = imageLocation.vault(backupHash + ("-" + accepterNum + "-signature.png"));
          } else {
            signatureImg = imageLocation.vault(backupHash + "-signature.png");
          }
          event.extra =
            '<div class="signature">\n  <div class="title">Electronic Signature</div>\n  <img src="' +
            signatureImg +
            '" alt="Signature">\n</div>';
        }
        if ((ref3 = acceptanceData.customForm) != null ? ref3.length : void 0) {
          fields = _.map(acceptanceData.customForm, function (item) {
            return {
              label: item.field,
              value: item.value,
            };
          });
          event.table = event.table.concat(fields);
        }
        return event;
      };
    }

    return AuditTrailRetriever;
  })();
}.call(this));
